module.exports = __webpack_public_path__ + "static/media/stedelijk.1fd23ab7.jpg";